import React, { useState } from 'react'
import { SkeletonList } from '../../components/Skeleton'
import {
  BackLink,
  ContentMaxWidth,
  Muted,
  PageHeading,
  PageSubheading,
  Pill,
  Stack,
} from '../../layout/styledComponents'
import { useSessionsList } from '../../hooks/useSessions'
import { usePatient } from '../../context/PatientContext'
import * as sessions from '../../services/sessionsService'
import SessionCard from './components/SessionCard'
import FeedbackDialog from './components/FeedbackDialog'

export default function PastSessionsPage() {
  const { currentProfile } = usePatient()
  const { data, loading, refresh } = useSessionsList('past')
  const [feedbackTarget, setFeedbackTarget] = useState(null)

  async function submit({ rating, text }) {
    if (!feedbackTarget) return
    await sessions.submitFeedback(currentProfile, feedbackTarget.eventId, { rating, text })
    refresh()
  }

  return (
    <ContentMaxWidth>
      <Stack $gap="20px">
        <BackLink to="/patient-home/sessions">Back to Sessions</BackLink>
        <div>
          <Pill>Sessions</Pill>
          <PageHeading style={{ marginTop: 12 }}>Past sessions</PageHeading>
          <PageSubheading>Recap, prescriptions, receipts, and feedback.</PageSubheading>
        </div>

        {loading && !data ? (
          <SkeletonList count={3} />
        ) : !data?.items?.length ? (
          <div
            style={{
              padding: '48px 24px',
              textAlign: 'center',
              border: '1px dashed rgba(31,41,55,0.18)',
              borderRadius: 20,
            }}
          >
            <p style={{ fontSize: 18, marginTop: 0, marginBottom: 8 }}>No past sessions yet.</p>
            <Muted>Once you&apos;ve had your first session, it&apos;ll appear here with the prescription and receipt.</Muted>
          </div>
        ) : (
          <Stack $gap="12px">
            {data.items.map((s) => (
              <SessionCard
                key={s.eventId}
                session={s}
                variant="past"
                onFeedback={(sess) => setFeedbackTarget(sess)}
              />
            ))}
          </Stack>
        )}
      </Stack>

      <FeedbackDialog
        open={!!feedbackTarget}
        session={feedbackTarget}
        onClose={() => setFeedbackTarget(null)}
        onSubmit={submit}
      />
    </ContentMaxWidth>
  )
}
